import React from "react";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Chip,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import SectionTimestampNotice from "./SectionTimestampNotice";

function ClientOnlyReviewSection({
  jobOrder = {},
  title = "For Client Only",
  isTechnician = false,
}) {
  const rating = Number(jobOrder?.satisfaction_rating) || 0;

  const remarks = jobOrder?.client_satisfaction_remarks || "";

  const clientRepresentative =
    jobOrder?.acknowledgedClientSignatory ||
    jobOrder?.acknowledged_client_signatory ||
    "";

  const acknowledgedSignature =
    jobOrder?.acknowledgedSignature ||
    jobOrder?.acknowledged_signature ||
    "";

  return (
    <>
      {/* Client Signature / Acknowledgement */}
      <Grid item xs={12}>
        <Card variant="outlined" sx={{ mb: 2 }}>
          <CardHeader
            title={
              <Typography
                variant="subtitle2"
                sx={{ fontWeight: "bold", textTransform: "uppercase" }}
              >
                Client Acknowledgement
              </Typography>
            }
            sx={{ px: 2, pt: 2, pb: 0 }}
          />

          <CardContent sx={{ px: 2, pb: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  label="Client Representative"
                  value={clientRepresentative}
                  fullWidth
                  size="small"
                  InputProps={{
                    readOnly: true,
                  }}
                />
              </Grid>

              {acknowledgedSignature ? (
                <Grid item xs={12}>
                  <Box
                    component="img"
                    src={acknowledgedSignature}
                    alt="Client Signature"
                    sx={{
                      display: "block",
                      width: "100%",
                      maxWidth: 400,
                      height: 140,
                      objectFit: "contain",
                      border: "1px solid rgba(0,0,0,0.3)",
                      borderRadius: 1,
                    }}
                  />
                </Grid>
              ) : null}

              <Grid item xs={12}>
                <SectionTimestampNotice
                  label="Client Signature Uploaded At"
                  value={jobOrder?.client_signature_uploaded_at}
                  colorSet="info"
                  hidden={isTechnician}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>

      {/* Satisfaction Rating */}
      <Grid item xs={12}>
        <Card variant="outlined" sx={{ mb: 2 }}>
          <CardHeader
            title={
              <Typography
                variant="subtitle2"
                sx={{ fontWeight: "bold", textTransform: "uppercase" }}
              >
                Satisfaction Rating
              </Typography>
            }
            sx={{ px: 2, pt: 2, pb: 0 }}
          />

          <CardContent sx={{ px: 2, pb: 2 }}>
            <Typography variant="body2" sx={{ mb: 2 }}>
              (1 – lowest, 5 – highest)
            </Typography>

            <Box
              sx={{
                display: "flex",
                gap: 1,
                mb: 2,
                flexWrap: "wrap",
                alignItems: "center",
              }}
            >
              {[1, 2, 3, 4, 5].map((n) => {
                const selected = rating === n;

                return (
                  <Chip
                    key={n}
                    label={n}
                    color={selected ? "primary" : "default"}
                    variant={selected ? "filled" : "outlined"}
                    sx={{
                      width: 44,
                      height: 44,
                      fontWeight: selected ? 700 : 500,
                      borderRadius: "50%",
                    }}
                  />
                );
              })}
            </Box>

            <Box>
              <Typography
                variant="caption"
                sx={{
                  display: "block",
                  mb: 0.75,
                  color: "text.secondary",
                  fontWeight: 500,
                  textTransform: "uppercase",
                }}
              >
                Additional Comments / Remarks
              </Typography>

              <Box
                sx={{
                  border: "1px solid rgba(0, 0, 0, 0.23)",
                  borderRadius: 1,
                  px: 1.5,
                  py: 1.25,
                  minHeight: 104,
                  backgroundColor: "rgba(205, 205, 205, 0.23)",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                    overflowWrap: "break-word",
                    lineHeight: 1.5,
                  }}
                >
                  {remarks || "—"}
                </Typography>
              </Box>
            </Box>

            <Grid container spacing={2} sx={{ mt: 0.5 }}>
              <Grid item xs={12}>
                <SectionTimestampNotice
                  label="Client Satisfaction Completed At"
                  value={
                    jobOrder?.client_satisfaction_completed_at ||
                    jobOrder?.satisfaction_completed_at
                  }
                  colorSet="info"
                  hidden={isTechnician}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </>
  );
}

export default ClientOnlyReviewSection;